import React from 'react'
import PropTypes from 'prop-types'
import { ActiveSpacer, ActiveStepName, ActiveStepNumber, CompletedStepNumber, Item, Spacer, StepNumber, StepName } from './stepbar-style'

import IconLike from '@assets/images/icon-like.svg'

const StepItem = ({ order, currentStep, label, last }) => {
  const isCurrentStep = currentStep === order
  const isCompletedStep = currentStep > order
  const isCurrentOrCompletedStep = currentStep >= order
  const isInativeStep = currentStep < order
  const isInativeSpacer = currentStep <= order

  return (
    <>
      <Item key={order}>
        {isCurrentStep && <ActiveStepNumber id={`active-step-number-${order}`}>{order}</ActiveStepNumber>}
        {isCompletedStep && (
          <CompletedStepNumber id={`completed-step-number-${order}`}>
            <img src={IconLike} />
          </CompletedStepNumber>
        )}
        {isInativeStep && <StepNumber id={`step-number-${order}`}>{order}</StepNumber>}

        {isCurrentOrCompletedStep ? (
          <ActiveStepName id={`active-step-name-${order}`}>{label}</ActiveStepName>
        ) : (
          <StepName id={`step-name-${order}`}>{label}</StepName>
        )}
      </Item>
      {isCompletedStep && !last && <ActiveSpacer id={`active-spacer-${order}`} />}
      {isInativeSpacer && !last && <Spacer id={`spacer-${order}`} />}
    </>
  )
}

StepItem.propTypes = {
  order: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  last: PropTypes.bool,
}
StepItem.displayName = 'Step-Item'

export default StepItem
